import { ITableColumns, ITableDataSource } from 'models/table';
import { EButtonVariants } from 'constants/Buttons';
import { EIconTypes } from 'constants/Icons';
import Button from 'components/atoms/Button';
import React from 'react';
import { IAddTrustedDeviceResponse } from 'models/trustedDevice';
import { formatDate } from 'utils/date';

export const mapTrustedDevicesToDataSource = (
  devices: IAddTrustedDeviceResponse[],
): ITableDataSource[] =>
  devices.map((device) => ({
    id: device.uniqueId,
    title: device.title,
    createdDate: device.createdDate,
    deviceToken: device.deviceToken,
  }));

interface ITrustedDevicesTableColumns {
  handleDelete: (arg: string) => void;
  longDateFormat: string;
}

export const trustedDevicesTableColumns = ({
  handleDelete,
  longDateFormat,
}: ITrustedDevicesTableColumns): ITableColumns[] => [
  {
    id: 'f0504ca5-6b32-482d-a169-304a6f32f511',
    key: 'title',
    title: 'userSettings.trustedDevices.trustedDevices.column',
    isSortable: false,
    render: (_data, props) =>
      `${props.title}, ${
        props.createdDate ? formatDate(props.createdDate, longDateFormat) : ''
      }`,
  },
  {
    id: 'f0504ca5-6b32-482d-a269-304a6f32f511',
    key: '',
    width: '100px',
    align: 'center',
    title: 'userSettings.trustedDevices.actions.column',
    isCenterTableHead: true,
    isSortable: false,
    render: (_data, props) => (
      <Button
        variant={EButtonVariants.outlined}
        tableButton={true}
        icon={EIconTypes.delete}
        onClick={() => handleDelete(props.id)}
      />
    ),
  },
];
